import {
  Component,
  Input,
} from '@angular/core';


@Component({
  selector: 'zx-qrcode',
  template: `<qr-code [value]="value" [size]="size" [level]="level" [mime]="mime" [background]="colorlight" [foreground]="colordark" [canvas]="usesvg"></qr-code>`,
  styleUrls: ['./qrcode.component.css']
})
export class QRCodeComponent {//implements OnChanges, OnInit {
  @Input() value: string = '';
  @Input() size: number = 256;
  @Input() padding: number = null;
  @Input() level: string|'L'|'M'|'Q'|'H' = 'M';
  @Input() colordark: string = '#000000';
  @Input() colorlight: string = '#ffffff';
  @Input() usesvg: boolean = false;
  @Input() mime: string = 'image/png';

  // private qrcode: any;
  // private qrcodeOptions: any;

  // constructor(
  //   private el: ElementRef
  // ) { }

  // ngOnInit() {
  //   this.newQRCode();
  // }

  // ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
  //   if (!this.qrcode) return;
  //   const value = changes['value'];
  //   if (value && value.currentValue && Object.keys(changes).length==1) {
  //     this.qrcode.clear();
  //     this.qrcode.makeCode(value.currentValue);
  //   }else{
  //     this.newQRCode();
  //   }
  // }

  // private newQRCode() {
  //   try {
  //     // if (!this.value) console.error('二维码内容不能为空');
  //     const qrcodeEl = this.el.nativeElement;
  //     while(qrcodeEl.firstChild) {
  //       qrcodeEl.removeChild(qrcodeEl.firstChild);
  //     }
  //     this.qrcode = new QRCode(this.el.nativeElement, {
  //       text: this.value,
  //       width: this.size,
  //       height: this.size,
  //       colorDark: this.colordark,
  //       colorLight: this.colorlight,
  //       useSVG: this.usesvg,
  //       correctLevel: QRCode.CorrectLevel[this.level.toString()]
  //     });
  //   } catch (e) {
  //     console.error('生成二维码错误: ' + e.message);
  //   }
  // }

}